module.exports = __webpack_public_path__ + "static/atrocity_rape_cases-199acfb36e56f31865feabaab3e317f8.png";